import { render, staticRenderFns } from "./MarketingBreakdownTable.vue?vue&type=template&id=59cfab31"
import script from "./MarketingBreakdownTable.vue?vue&type=script&lang=js"
export * from "./MarketingBreakdownTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports